import "./LocationUserViewComponent.scss";
import ButtonComponent from "../../../../../shared/components/core/button/ButtonComponent";
import {Edit} from "@mui/icons-material";
import AccordionComponent from "../../../../../shared/components/accordion/accordionComponent";
import {CommonService} from "../../../../../shared/services";
import UserDetailsComponent from "../../../../../shared/components/user-details/UserDetailsComponent";
import React, {useEffect, useState} from "react";

interface LocationUserViewComponentProps {
    userList?: any;
    onEditModeOpen?: Function;
    onUpdateComplete: Function;
    canEdit: boolean;
}

const LocationUserViewComponent = (props: LocationUserViewComponentProps) => {
    const {userList, onEditModeOpen, canEdit} = props;

    const [userDetailsList, setUserDetailsList] = useState<any[]>([]);


    useEffect(() => {
        if (userList?.length > 0) {
            setUserDetailsList(userList)
        }
    }, [userList]);
    return (
        <div className={'location-user-view-component assigned-user-view-tab'}>
            {!userDetailsList?.length ?
                <div className={'no-assigned-user-wrapper'}>
                    <div className='no-assigned-user-header'>
                        No User have been added to this location.
                    </div>
                    <div className={'no-assigned-user-button'}>
                        {canEdit &&
                            <ButtonComponent
                                variant={"outlined"}
                                // className={'width-50'}
                                fullWidth={true}
                                handleClick={onEditModeOpen}
                            >
                                Assign User
                            </ButtonComponent>
                        }
                    </div>
                </div> :
                <div
                    className={'d-flex justify-content-space-between align-items-center mrg-bottom-10'}>
                    <div className="form-sub-title mrg-top-15">Added Users</div>
                    {
                        canEdit &&
                        <ButtonComponent
                            variant={"outlined"}
                            fullWidth={false}
                            type={'button'}
                            color={"primary"}
                            handleClick={onEditModeOpen}
                            startIcon={<Edit/>}
                        >
                            Edit Details
                        </ButtonComponent>
                    }
                </div>
            }
            {userDetailsList?.map((user: any, index: any) => {
                return (
                    <div key={index} className="accordion-layout mrg-bottom-20">
                        <AccordionComponent
                            isExpanded={userList[index]?.isLocationUserExpand}
                            title={`${CommonService.capitalizeFirstLetter(user.firstName)} ${CommonService.capitalizeFirstLetter(user.middleName)} ${CommonService.capitalizeFirstLetter(user.lastName)}`}
                            subTitle={`(User ID: ${user?.id} | ${userList[index]?.roleObj?.title || ""})`}
                        >
                            <UserDetailsComponent user={user}/>
                        </AccordionComponent>
                    </div>
                )
            })
            }
        </div>
    );

};

export default LocationUserViewComponent;
